import { render, staticRenderFns } from "./ApproveBooking.vue?vue&type=template&id=021ade5a"
import script from "./ApproveBooking.vue?vue&type=script&lang=js"
export * from "./ApproveBooking.vue?vue&type=script&lang=js"
import style0 from "./ApproveBooking.vue?vue&type=style&index=0&id=021ade5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports